const motorHtColumns = [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'deviceCode',
    key: 'deviceCode',
    width: 280
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 360
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 160
  },
  {
    zh: '平均电机绕组温度(℃)',
    en: 'Average Motor Winding Temperature(℃)',
    dataIndex: 'avgMotorWindingTemp',
    key: 'avgMotorWindingTemp',
    tooltip: true
  },
  {
    zh: '最大电机绕组温度(℃)',
    en: 'Maximum Motor Winding Temperature(℃)',
    dataIndex: 'maxMotorWindingTemp',
    key: 'maxMotorWindingTemp',
    tooltip: true
  },
  {
    zh: '平均环境温度(℃)',
    en: 'Average Environment Temperature(℃)',
    dataIndex: 'avgEnvTemp',
    key: 'avgEnvTemp',
    tooltip: true
  },
  {
    zh: '最大环境温度(℃)',
    en: 'Maximum Environment Temperature(℃)',
    dataIndex: 'maxEnvTemp',
    key: 'maxEnvTemp',
    tooltip: true
  }
]

export default motorHtColumns